import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';

export enum Views {
    BOOT = 'boot',
    MAP = 'map',
    GAME = 'game',
    PREGAME = 'pregame',
    EDITOR = 'editor',
}

export const defaultView = Views.BOOT;

export const StateView = (state = defaultView, action: fromActions.Actions): string => {
    switch (action.type) {
        case ActionTypes.START_LEVEL:
            return Views.GAME;
        case ActionTypes.CHANGE_VIEW:
            return action.payload;
        default:
            return state;
    }
};
